export default __webpack_public_path__ + "static/media/icon-poubelle-btn.156663c5.svg";